export default __webpack_public_path__ + "static/media/DisabledEdit.c802d2df.svg";